import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { ToasterService } from '../../../shared/services/toaster/toaster.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loading: boolean = false;
  email: string = '';
  password: string = '';

  constructor(
    private Router: Router,
    private AuthService: AuthService,
    private Toaster: ToasterService,
  ) { }
  
  ngOnInit(): void {
    // Check for existing VALID token
    if (this.AuthService.isAuthenticated()) {
      this.Router.navigate(['/auth/are-you-sure']);
    }

  }

  public async login() {
    try {
      this.loading = true;

      // Guard against missing credentials
      if (!this.email) {
        this.Toaster.warning("Missing email", 4000);
        return
      }

      if (!this.password) {
        this.Toaster.warning("Missing password", 4000);
        return
      }

      // Authenticate using AuthService
      const isAuthenticated = await this.AuthService.login(this.email, this.password);

      if (isAuthenticated) {
        this.Toaster.success("Login successful", 4000);
        this.Router.navigate(['/files/folders']); // Redirect on success
      } else {
        throw new Error("Credentials are incorrect or account does not exist");
      }
    } catch (error: any) {
      console.error('Login error:', error.message || error);
      // Display error message (replace with Toaster if available)
      this.Toaster.warning(`Login error: ${error.message || error}`, 4000);
    } finally {
      this.loading = false;
    }
  }
}